// Single source of the platform's identity name. Defaults are the approved wording; the admin «الإعدادات» values
// (site_name / site_name_en) override them at runtime so every surface (header, footer, titles, OG, JSON-LD, share) follows.
export const DEFAULT_SITE_NAME = {
    ar: "الصحفي علي سالم - غزة",
    en: "Journalist Ali Salem - Gaza",
    es: "Periodista Ali Salem - Gaza",
    nl: "Journalist Ali Salem - Gaza",
};
export const AUTHOR_NAME = { ar: "علي سالم", en: "Ali Salem" };

const current = { ...DEFAULT_SITE_NAME };

export function applySiteIdentity(settings) {
    const ar = (settings?.site_name || "").trim();
    const en = (settings?.site_name_en || "").trim();
    current.ar = ar || DEFAULT_SITE_NAME.ar;
    current.en = en || DEFAULT_SITE_NAME.en;
    current.es = en || DEFAULT_SITE_NAME.es;
    current.nl = en || DEFAULT_SITE_NAME.nl;
}

export const siteName = (lang = "ar") => current[lang] || current.en;
export const authorName = (lang = "ar") => (lang === "ar" ? AUTHOR_NAME.ar : AUTHOR_NAME.en);
